export default __webpack_public_path__ + "static/media/login_bg_image.29d4755f.jpg";